(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/views/statteamoffensedefense.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/views/statteamoffensedefense.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamOffenseDefense = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatTeamOffenseDefense',
    viewId: 'statistik',
    PAGE_SIZE: 10,
    filters: {
      teamStatsHomeAwayFilter: {
        filterValues: {
          total: { name: 'Alla', selected: true },
          home: { name: 'Hemma', selected: false },
          away: { name: 'Borta', selected: false }
        },
        selectedKey: 'total'
      },
      teamStatsTypeFilter: {
        filterValues: {
          numGoalsPerMatchFor: {
            name: 'Offensiv',
            sortMultiplicator: -1,
            selected: true
          },
          numGoalsPerMatchAgainst: {
            name: 'Defensiv',
            sortMultiplicator: 1,
            selected: false
          }
        },
        selectedKey: 'numGoalsPerMatchFor'
      },
      teamStatsQuantity: 0,
      teamStatsMoreExists: true
    },
    events: {
      'change #teamStatsTypeFilter': 'selectMenu',
      'change #teamStatsHomeAwayFilter': 'selectMenu',
      'click #teamStatsQuantity': 'moreButton'
    },
    initialize: function(options) {
      this.modelReference = options.modelReference;
      this.options = options.options;
      this.filters.teamStatsQuantity = this.PAGE_SIZE;
    },
    update: function(model) {
      this.modelReference = model;
      this.render({});
    },
    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },
    render: function() {
      if (!this.modelReference) return;

      $(this.el).html(
        svs.statistics.teamstatistics.templates.statteamoffensedefense(
          this.applyFilters()
        )
      );
      this.resize();
      return this;
    },
    selectMenu: function(event) {
      var selectedVal = $(event.currentTarget).val();
      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;
      var me = this;
      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
          me.filters[$(event.currentTarget).attr('id')].filterValues[
            selectedVal
          ].selected = true;
        }
      );
      this.filters.teamStatsQuantity = this.PAGE_SIZE;
      this.render({});
    },
    applyFilters: function() {
      var teams = this.modelReference.get('teamsOffenseDefense');
      teams = this.setupOffensiveDefensiveModule(teams);

      return {
        teams: teams,
        filters: this.filters
      };
    },
    setupOffensiveDefensiveModule: function(teams) {
      var self = this,
        position = 1;

      teams = _.sortBy(teams, function(teamstat) {
        return teamstat.team.name;
      });

      this.filters.teamStatsMoreExists =
        _.size(teams) > this.filters.teamStatsQuantity;

      teams = _.sortBy(teams, function(teamstat) {
        if (
          teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
            self.filters.teamStatsTypeFilter.selectedKey
          ] === null
        ) {
          return;
        }
        return (
          parseFloat(
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
              self.filters.teamStatsTypeFilter.selectedKey
            ].replace(',', '.')
          ) *
          self.filters.teamStatsTypeFilter.filterValues[
            self.filters.teamStatsTypeFilter.selectedKey
          ].sortMultiplicator
        );
      });

      teams = _.first(teams, this.filters.teamStatsQuantity);

      _.each(teams, function(teamstat) {
        teamstat.valueText =
          teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
            self.filters.teamStatsTypeFilter.selectedKey
          ];
        teamstat.valueText = teamstat.valueText
          ? teamstat.valueText.toString().replace('.', ',')
          : '';

        if (
          self.filters.teamStatsTypeFilter.selectedKey === 'numGoalsPerMatchFor'
        ) {
          teamstat.labelText =
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
              .numGoalsFor +
            ' gjorda mål på ' +
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
              .numMatches +
            ' matcher';
        } else {
          teamstat.labelText =
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
              .numGoalsAgainst +
            ' insläppta mål på ' +
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
              .numMatches +
            ' matcher';
        }
        teamstat.position = position++;
      });
      return teams;
    },
    moreButton: function(event) {
      this.filters[$(event.currentTarget).attr('id')] += this.PAGE_SIZE;
      this.render({});
    },
    onDestroy: function() {
      this.undelegateEvents();
      if (this.modelReference) {
        this.modelReference.off('change', this.render, this);
      }
      this.remove();
      Backbone.View.prototype.remove.call(this);
    }
  });
})(Backbone, _, svs);

 })(window);